module.exports = __webpack_public_path__ + "static/media/ancianos.a5c48af3.png";